<style>

    html, body {
        position: relative;
        height: 100%;
        font-size: 12px;
    }

    .swiper-container {
        width: 100%;
        height: 100%;
    }

    body:after {
        background-image: url('../imgs/index_bg_03.jpg'); background-repeat: no-repeat; background-size: cover;
    }

    /*
     * pan_height_line1
     */

    .pan_height_line1_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_zh {
            height: 360px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_zh {
            height: 340px;
            /*height: 315px;*/
        }
    }

    .pan_height_line1_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line1_en {
            height: 360px;
            /*height: 415px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line1_en {
            height: 340px;
            /*height: 370px;*/
        }
    }

    /*
     * pan_height_line2
     */

    .pan_height_line2_zh {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 294px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_zh {
            height: 220px;
            /*height: 306px;*/
        }
    }

    .pan_height_line2_en {
        height: auto;
    }
    @media (min-width: 992px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 355px;*/
        }
    }
    @media (min-width: 1200px) {
        .pan_height_line2_en {
            height: 220px;
            /*height: 346px;*/
        }
    }

    .container-margin-bottom {
        margin-bottom: 10px;
    }
    @media (min-width: 768px) {
        .container-margin-bottom {
            margin-bottom: 60px;
        }
    }

    .pan-num {
        text-align: center;
        font-size: 80px;
        /*color: #F29700;*/
        color: #D3A571;
        padding-left: 20px;
        padding-top: 25px;
    }
    @media (min-width: 768px) {
        .pan-num {
            font-size: 144px;
            padding-top: 0;
        }
    }

    .pan-num-size {
        width: 80px;
    }

    @media (min-width: 768px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 992px) {
        .pan-num-size {
            width: 130px;
        }
    }

    @media (min-width: 1200px) {
        .pan-num-size {
            width: 150px;
        }
    }

    .pan-01-wrapper {
        padding: 0px 0px 30px 0px;
    }

    @media (min-width: 768px) {
        .pan-01-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    @media (min-width: 1200px) {
        .pan-01-wrapper {
            padding: 0px 45px 30px 0px;
        }
    }

    .pan-01 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_01_bg.png");
        background-position-x: right;
        background-position-y: top;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-01 {
            background-size: 15% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-01 {
            background-size: 30% auto;
        }
    }

    .pan-01b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-01b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-01b-size {
            width: 70%;
        }
    }

    .pan-01-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-01-detail-size {
            width: 85%;
        }
    }
    @media (min-width: 992px) {
        .pan-01-detail-size {
            width: 70%;
        }
    }

    .pan-02-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-02 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_02_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 20% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-02 {
            background-size: 20% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-02 {
            background-size: 28%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02 {
            background-size: auto;
        }
    }


    .pan-02b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-02b-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02b-size {
            width: 65%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02b-size {
            width: 60%;
        }
    }

    .pan-02-detail-size {
        width: 85%;
    }
    @media (min-width: 768px) {
        .pan-02-detail-size {
            width: 80%;
        }
    }
    @media (min-width: 992px) {
        .pan-02-detail-size {
            width: 68%;
        }
    }
    @media (min-width: 1200px) {
        .pan-02-detail-size {
            width: 65%;
        }
    }

    /*
    ***************     pan-03
    */


    .pan-03-wrapper {
        padding: 0px 0px 30px 0px;
    }
    @media (min-width: 768px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
        }
    }

    @media (min-width: 992px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }

    @media (min-width: 1200px) {
        .pan-03-wrapper {
            padding: 0px 0px 30px 0px;
            /*padding: 0px 45px 30px 0px;*/
        }
    }



    .pan-03 {
        background: #FFFFFF;
        background-image: url("../imgs/biz_content_03_bg.png");
        background-position-x: right;
        background-position-y: bottom;
        background-repeat:no-repeat;
        background-size: 25% auto;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    @media (min-width: 768px) {
        .pan-03 {
            background-size: 28% auto;
        }
    }

    @media (min-width: 992px) {
        .pan-03 {
            background-size: 31% auto;
        }
    }
    @media (min-width: 1200px) {
        .pan-03 {
            background-size: 33% auto;
        }
    }


    .pan-03b-size {
        width: 70%;
    }
    @media (min-width: 768px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 992px) {
        .pan-03b-size {
            width: 75%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03b-size {
            width: 80%;
        }
    }

    .pan-03-detail-size {
        width: 80%;
    }
    @media (min-width: 768px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 992px) {
        .pan-03-detail-size {
            width: 70%;
        }
    }
    @media (min-width: 1200px) {
        .pan-03-detail-size {
            width: 65%;
        }
    }

    .pan-04-wrapper {
        padding: 0px 0px 30px 0px;
    }

    .pan-04 {
        background: RGBA(0,0,0,0.5);
        box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    }

    .content-style {
        background-color: #fff;
        margin: 0;
        padding: 20px 0 20px 0;
    }
    @media (min-width: 768px) {
        .content-style {
            background-color: #FFFFFF;
            margin: 0 20px 80px 20px;
            padding: 20px 25px 20px 25px;
        }
    }
    .item-padding {
        height: 893px;
        padding: 0 0 0 0;
    }
    @media (min-width: 768px) {
        .item-padding {
            padding: 0 25px 0 25px;
        }
    }
    .jieshao_ul ul{ display: flex; flex-wrap: wrap; justify-content: space-between; padding: 0; margin: 0 20px;}
    .jieshao_ul li{ width: 31%; padding-bottom: 20px; margin-bottom: 30px; background: #FFFFFF; box-shadow: rgb(0 0 0 / 50%) 0px 2px 4px; text-align: center; list-style-type: none;}
    .jieshao_ul li img{ width: 100%; height: 240px; object-fit: cover;}
    .jieshao_ul li h3{ margin: 20px 0 10px 0; color: #4a4a4a; font-size: 22px; font-weight: bold; text-align: center;}
    .jieshao_ul li p{ margin: 0 10px; font-size: 16px; color: #9b9b9b; line-height: 24px;}
    @media (max-width: 992px) {
        .jieshao_ul li{ width: 100%;}
        .tx-page-title{ margin-left:0px;margin-right:0px;}
    }
</style>

<template>
    <div class="container container-margin-bottom">
        <div class="tx-page-title">集体学习</div>
        <!--正文内容-->
        <div class="container-fluid content-style">
            <div class="jieshao_ul">
                <ul>
                    <li>
                        <img src="imgs/culture_xx/44.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2026年4月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>腾讯Work Buddy智能体应用分享</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/43.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2026年3月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>OPEN CLAW学习与应用</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/42.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年12月27日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>AI工具挑战赛2.0</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/41.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年11月30日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>AI应用实战培训</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/40.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年10月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>AI工具挑战赛</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/39.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年9月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>AI应用学习分享</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/38.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年9月1日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>南站喜街乐跑赛</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/37.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年7月26日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>亚运城喜街参观考察<br>《关于企业与个人成长的思考》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/36.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年5月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>1906科技园扬韬广场参观考察</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/35.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年4月27日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>三七互娱全球总部参观考察</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/34.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年3月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>东谷中心商业参观考察</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/33.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2025年2月5日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>2025开年登山活动</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/32.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年11月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《价值主张Ⅱ》内部研讨会</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/31.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年10月26日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《价值主张》内部研讨会</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/30.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年9月21日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>2024南站喜街乐跑赛</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/29.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年8月24日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>深化军队文化建设<br>《我们的时代，我们的奋斗》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/28.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年7月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>中国经济形势分析</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/27.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年6月29日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《TED》演讲视频合集学习与讨论</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/26.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年5月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>保利鱼珠时光商业参观考察<br>美林M·LIVE天地商业参观考察</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/25.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年4月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>思维导图与PPT应用大比武</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/24.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年3月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>PPT与思维导图深化运用</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/23.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2024年2月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>黄埔军校旧址参观学习</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/22.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年12月16日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>业务本领学习与复盘</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/21.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年11月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>业务本领学习与复盘</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/20.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年10月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>业务本领学习与复盘</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/19.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年9月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>熙二戈壁110公里感悟分享</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/18.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年8月16日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>香港商业街区走访学习</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/17.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年7月29日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>亚运城喜街项目历程分享及实地走访</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/16.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年7月1日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《营销平台研究与探索》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/01.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年5月27日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>ChatGPT实操</p>
                            <p>《对标企业商业模式研究》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/02.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年4月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《所有人都能玩转的ChatGPT》</p>
                            <p>《我国发展商业地产REITS模式研究》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/03.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年3月26日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《人工智能》</p>
                            <p>《房地产投资信托基金》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/04.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2023年2月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>同熙商业3.0模式复盘</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/05.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年12月31日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>大夫山户外拓展学习会</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/06.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年11月26日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《海外市场商业地产现状及动向》</p>
                            <p>《数字化建设案例或实践学习》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/07.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年10月29日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《深化军队文化建设》系列</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/08.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年9月18日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>“熙一”十人分享感悟</p>
                            <p>《一人一厨一狗》华为系列故事学习</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/09.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年8月28日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《向军队学习执行力》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/10.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年7月23日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《苏世民：我的经验与教训》</p>
                            <p>《商业运营学习分享》</p>
                            <p>《公司法》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/11.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年6月25日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《商业地产的投资要点与难点》</p>
                            <p>《商业地产的营销要点与难点》</p>
                            <p>《商业地产的商管运营要点与难点》</p>
                            <p>《我在世界五百强的工作经验》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/12.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年5月21日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《建立学习型团队》</p>
                            <p>《活到老学到老》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/13.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年4月16日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《访问美军院校见闻》</p>
                            <p>《康熙五十六年谕旨》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/14.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年3月19日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《黄奇帆独家解读房地产》</p>
                            <p>《灰度法则打造华为常胜铁军》</p>
                        </div>
                    </li>
                    <li>
                        <img src="imgs/culture_xx/15.jpg">
                        <div class="box">
                            <h3>学习时间</h3>
                            <p>2022年2月19日</p>
                        </div>
                        <div class="box">
                            <h3>学习内容</h3>
                            <p>《华为如何锻造打胜仗的组织》</p>
                            <p>《华为向军队学习了什么》</p>
                        </div>
                    </li>
                    <li style="visibility: hidden;height: 0;margin: 0;"></li>
                    <li style="visibility: hidden;height: 0;margin: 0;"></li>
                    <li style="visibility: hidden;height: 0;margin: 0;"></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

    module.exports = {
        computed: {
            pan_height_line1: function () {
                return {
                    pan_height_line1_zh: this.$i18n.locale != 'en_US',
                    pan_height_line1_en: this.$i18n.locale == 'en_US',
                }
            },
            pan_height_line2: function () {
                return {
                    pan_height_line2_zh: this.$i18n.locale != 'en_US',
                    pan_height_line2_en: this.$i18n.locale == 'en_US',
                }
            }
        },
        mounted: function () {

            $('#fundCert').viewer({
                scalable: false,
                navbar: false,
                title: false,
                toolbar: false,
                url: 'data-original'
            });
            window.pageTitle = {
                en_US: this.$i18n.messages.en_US.page_title_culture,
                zh_HK: this.$i18n.messages.zh_HK.page_title_culture,
                zh_CN: this.$i18n.messages.zh_CN.page_title_culture
            };
            window.setTitle(window.pageTitle[this.$i18n.locale]);
        }

    };

</script>


// WEBPACK FOOTER //
// culture_xx.vue?2204e6ec